import { AdminClient } from "@workspace/admin-domain/src/features/client/schema";
import { t } from "i18next";
import * as z from "zod";

export const CLIENT_SORT_OPTIONS: {
  label: string;
  kv: `${AdminClient["SortBy"][number]}_${AdminClient["SortOrder"][number]}`;
  value: {
    key: AdminClient["SortBy"][number];
    order: AdminClient["SortOrder"][number];
  };
}[] = [
  {
    label: t("clients.sort.name_asc"),
    kv: "name_asc",
    value: { key: "name", order: "asc" },
  },
  {
    label: t("clients.sort.name_desc"),
    kv: "name_desc",
    value: { key: "name", order: "desc" },
  },
  {
    label: t("clients.sort.phone_asc"),
    kv: "phone_asc",
    value: { key: "phone", order: "asc" },
  },
  {
    label: t("clients.sort.phone_desc"),
    kv: "phone_desc",
    value: { key: "phone", order: "desc" },
  },
  {
    label: t("clients.sort.totalBookings_asc"),
    kv: "totalBookings_asc",
    value: { key: "totalBookings", order: "asc" },
  },
  {
    label: t("clients.sort.totalBookings_desc"),
    kv: "totalBookings_desc",
    value: { key: "totalBookings", order: "desc" },
  },
  {
    label: t("clients.sort.totalSpent_asc"),
    kv: "totalSpent_asc",
    value: { key: "totalSpent", order: "asc" },
  },
  {
    label: t("clients.sort.totalSpent_desc"),
    kv: "totalSpent_desc",
    value: { key: "totalSpent", order: "desc" },
  },
  {
    label: t("clients.sort.lastTripDate_asc"),
    kv: "lastTripDate_asc",
    value: { key: "lastTripDate", order: "asc" },
  },
  {
    label: t("clients.sort.lastTripDate_desc"),
    kv: "lastTripDate_desc",
    value: { key: "lastTripDate", order: "desc" },
  },
  {
    label: t("clients.sort.createdAt_asc"),
    kv: "createdAt_asc",
    value: { key: "createdAt", order: "asc" },
  },
  {
    label: t("clients.sort.createdAt_desc"),
    kv: "createdAt_desc",
    value: { key: "createdAt", order: "desc" },
  },
] as const;

export const DEFAULT_CLIENTS_PARAMS = {
  page: 0,
  limit: 10,
  sortBy: "createdAt",
  sortOrder: "desc",
} satisfies AdminClient["GetAll"];

export const ClientFiltersSchema = AdminClient.GetAll.partial({
  page: true,
  limit: true,
  sortBy: true,
  sortOrder: true,
});
export type ClientFiltersSchema = z.infer<typeof ClientFiltersSchema>;
